/**
 * Zod schemas for devcontainer feature preferences
 */

import { z } from 'zod';

// Passthrough, not zod's default strip: the admin Feature dialog edits and
// PUTs back the parsed schema, so any key dropped here (e.g. `env`,
// `enum_source`) would be silently deleted from the stored feature.
export const OptionSchemaEntrySchema = z
  .object({
    type: z.string(),
    // Optional: an entry may have no default (claude-code 4.1.0's `model`,
    // whose choices come from the AI gateway at serve time).
    default: z
      .union([z.string(), z.number(), z.boolean(), z.array(z.string())])
      .nullable()
      .optional(),
    admin_only: z.boolean(),
    label: z.string(),
    description: z.string(),
    enum: z.array(z.string()).nullable().optional(),
    // "ai_models": `enum` is materialized server-side from the gateway's
    // enabled models (and dropped again before the backend persists).
    enum_source: z.string().nullable().optional(),
    env: z.string().nullable().optional(),
    depends_on: z.string().nullable().optional(),
    enum_map: z.record(z.string(), z.array(z.string())).nullable().optional(),
    enum_labels: z.record(z.string(), z.string()).optional(),
  })
  .passthrough();

export const ConfigurableFeatureSchema = z.object({
  feature_id: z.string(),
  feature_name: z.string(),
  display_name: z.string(),
  category: z.string(),
  configurable_options: z.record(z.string(), OptionSchemaEntrySchema),
  current_values: z.record(z.string(), z.unknown()),
});

export const ConfigurableFeaturesResponseSchema = z.object({
  features: z.array(ConfigurableFeatureSchema),
});

export type OptionSchemaEntry = z.infer<typeof OptionSchemaEntrySchema>;
export type ConfigurableFeature = z.infer<typeof ConfigurableFeatureSchema>;
